import { takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import * as customersActions from './actions';
import { apiSagaV2 } from '../../../helpers/saga';
import { AdminApi } from 'src/api';

const getCustomersListSaga = apiSagaV2(
  customersActions.getCustomersList,
  async (connection, action) => {
    return new AdminApi(connection).getCustomersList();
  }
);

export function* customersSaga() {
  yield takeEvery(getType(customersActions.getCustomersList.request), getCustomersListSaga);
}
